const COUNTRY_DISPLAY_NAMES = {
  KR: "대한민국",
  KOREA: "대한민국",
  "SOUTH KOREA": "대한민국",
  "REPUBLIC OF KOREA": "대한민국",
  US: "미국",
  USA: "미국",
  "UNITED STATES": "미국",
  "UNITED STATES OF AMERICA": "미국",
  VN: "베트남",
  VIETNAM: "베트남",
  JP: "일본",
  JAPAN: "일본",
  CN: "중국",
  CHINA: "중국",
};

export function normalizeCountryCode(country) {
  const raw =
    typeof country === "string"
      ? country
      : country?.code ??
        country?.country_code ??
        country?.country_id ??
        country?.country ??
        "";

  return String(raw)
    .trim()
    .toUpperCase();
}

export function getCountryDisplayName(country) {
  const code = normalizeCountryCode(country);
  return (
    COUNTRY_DISPLAY_NAMES[code] ??
    country?.country ??
    country?.default_name ??
    country?.country_name ??
    country?.name ??
    code
  );
}

export function formatCountryLabel(country) {
  return getCountryDisplayName(country) || "-";
}
